/// <reference types="./project.d.mts" />
import * as $file_ from "../../../common/data/ephemeral/file.mjs";
import * as $project from "../../../common/data/project.mjs";
import * as $assoc from "../../../common_common/gleam/assoc.mjs";
import * as $file from "../../../ds/web/browser/file.mjs";
import * as $form_data from "../../../gleam_fetch/gleam/fetch/form_data.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $stdlib$dict from "../../../gleam_stdlib/dict.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $toast from "../../../grille_pain/grille_pain/lustre/toast.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $mime_types from "../../../mime_types/mime_types.mjs";
import * as $state from "../../data/model/state.mjs";
import { State } from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $proposals from "../../data/proposals.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $effects from "../../frontend/effects.mjs";
import * as $modal_effects from "../../frontend/effects/modal.mjs";
import * as $project_effects from "../../frontend/effects/project.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import {
  Ok,
  toList,
  CustomType as $CustomType,
  bitArraySlice,
  bitArraySliceToInt,
  BitArray as $BitArray,
  List as $List,
  UtfCodepoint as $UtfCodepoint,
} from "../../gleam.mjs";

export function update(state, msg) {
  if (msg instanceof $msg.ApiDeletedProject) {
    let project_id = msg.project_id;
    return [$state.delete_project(state, project_id), $effect.none()];
  } else if (msg instanceof $msg.ApiReturnedProjects) {
    let projects = msg.projects;
    let updating = msg.updating;
    let _pipe = $state.upsert_projects(state, projects);
    let _block;
    let $ = state.loading.projects;
    if ($) {
      _block = $state.empty_proposal_builder;
    } else {
      _block = $function.identity;
    }
    let _pipe$1 = _block(_pipe);
    return $pair.new$(
      _pipe$1,
      (() => {
        if (updating) {
          return $toast.success("Your project has correctly been updated!");
        } else {
          return $effect.none();
        }
      })(),
    );
  } else if (msg instanceof $msg.BrowserExtractedNewProjectAttachments) {
    let id = msg.id;
    let attachments = msg.attachments;
    let $ = $list.key_find(state.projects, id);
    if ($ instanceof Ok) {
      let project = $[0];
      let _block;
      let _record = project;
      _block = new $project.Project(
        _record.id,
        _record.name,
        _record.owners,
        _record.org_id,
        _record.deadline,
        _record.client,
        _record.collaborators,
        (() => {
          let _record$1 = project.metadata;
          return new $project.Metadata(
            $list.append(
              project.metadata.attachments,
              $list.map(
                attachments,
                (_use0) => {
                  let name = _use0.name;
                  let mime_type = _use0.mime_type;
                  return new $project.Attachment(name, mime_type);
                },
              ),
            ),
            _record$1.integrations,
          );
        })(),
        _record.created_at,
        _record.status,
      );
      let _pipe = _block;
      let _pipe$1 = $list.wrap(_pipe);
      let _pipe$2 = ((_capture) => {
        return $state.upsert_projects(state, _capture);
      })(_pipe$1);
      return $pair.new$(
        _pipe$2,
        $middleware.require_access_token(
          (access_token) => {
            return $effect.from(
              (_) => {
                let _pipe$3 = $ask.to(
                  new $ask.Heimdall(),
                  toList(["projects", "attachments"]),
                );
                let _pipe$4 = $ask.bearing(_pipe$3, access_token);
                let _pipe$5 = $ask.via(_pipe$4, new $http.Post());
                let _pipe$6 = $ask.data(
                  _pipe$5,
                  (() => {
                    let _pipe$6 = $list.fold(
                      attachments,
                      $form_data.new$(),
                      (acc, attachment) => {
                        let mime = $mime_types.to_string(attachment.mime_type);
                        let name = (mime + "_") + attachment.name;
                        return $form_data.append_bits(
                          acc,
                          name,
                          attachment.content,
                        );
                      },
                    );
                    return $form_data.append(
                      _pipe$6,
                      "_steerlab_project_id",
                      id,
                    );
                  })(),
                );
                $ask.run(_pipe$6)
                return undefined;
              },
            );
          },
        ),
      );
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserSavedProjectTitle) {
    let id = msg.id;
    let blur = $effects.blur_active_element();
    let update$1 = $project_effects.update_project(state, id, false);
    return [state, $effect.batch(toList([blur, update$1]))];
  } else if (msg instanceof $msg.UserToggledCollapsedProject) {
    let project = msg.project;
    let _pipe = $dict.get(state.opened_projects, project.id);
    let _pipe$1 = $result.unwrap(_pipe, false);
    let _pipe$2 = $bool.negate(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $dict.insert(state.opened_projects, project.id, _capture);
    })(_pipe$2);
    let _pipe$4 = ((opened_projects) => {
      let _record = state;
      return new State(
        _record.window_dimensions,
        _record.access_token,
        _record.analytics,
        _record.client,
        _record.collapsed_navbar,
        _record.comments,
        _record.comments_draft_mentions,
        _record.comments_in_edition,
        _record.connectors,
        _record.content_library,
        _record.copilot,
        _record.custom_rewording_input,
        _record.draft_comments,
        _record.dropdown_unsubscriber,
        _record.feed_opened,
        _record.language,
        _record.loading,
        _record.modal,
        _record.modal_unsubscriber,
        _record.notifications,
        _record.notifications_unread,
        opened_projects,
        _record.organization,
        _record.permissions,
        _record.projects,
        _record.proposal_builder,
        _record.proposals,
        _record.qualification_matrix,
        _record.route,
        _record.running_requests,
        _record.translations,
        _record.user,
        _record.sources_tooltip,
        _record.sources_tooltip_unsubscriber,
        _record.maintenance,
      );
    })(_pipe$3);
    return $pair.new$(_pipe$4, $effect.none());
  } else if (msg instanceof $msg.UserToggledProjectCollaborator) {
    let project_id = msg.project_id;
    let user_id = msg.user_id;
    let _pipe = state.projects;
    let _pipe$1 = $list.key_find(_pipe, project_id);
    let _pipe$2 = $result.map(
      _pipe$1,
      (_capture) => { return $project.toggle_collaborator(_capture, user_id); },
    );
    let _pipe$3 = $result.map(_pipe$2, $list.wrap);
    let _pipe$4 = $result.map(
      _pipe$3,
      (_capture) => { return $state.upsert_projects(state, _capture); },
    );
    let _pipe$5 = $result.unwrap(_pipe$4, state);
    return $pair.new$(
      _pipe$5,
      $project_effects.toggle_project_collaborator(state, project_id, user_id),
    );
  } else if (msg instanceof $msg.UserToggledProjectTitle) {
    let _pipe = state.proposals;
    let _pipe$1 = $proposals.toggle_title(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_proposals(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedProjectTitle) {
    let id = msg.id;
    let name = msg.title;
    let $ = $list.key_find(state.projects, id);
    if ($ instanceof Ok) {
      let proposal = $[0];
      let _block;
      let _record = proposal;
      _block = new $project.Project(
        _record.id,
        name,
        _record.owners,
        _record.org_id,
        _record.deadline,
        _record.client,
        _record.collaborators,
        _record.metadata,
        _record.created_at,
        _record.status,
      );
      let _pipe = _block;
      let _pipe$1 = ((_capture) => {
        return $list.key_set(state.projects, id, _capture);
      })(_pipe);
      let _pipe$2 = ((projects) => {
        let _record$1 = state;
        return new State(
          _record$1.window_dimensions,
          _record$1.access_token,
          _record$1.analytics,
          _record$1.client,
          _record$1.collapsed_navbar,
          _record$1.comments,
          _record$1.comments_draft_mentions,
          _record$1.comments_in_edition,
          _record$1.connectors,
          _record$1.content_library,
          _record$1.copilot,
          _record$1.custom_rewording_input,
          _record$1.draft_comments,
          _record$1.dropdown_unsubscriber,
          _record$1.feed_opened,
          _record$1.language,
          _record$1.loading,
          _record$1.modal,
          _record$1.modal_unsubscriber,
          _record$1.notifications,
          _record$1.notifications_unread,
          _record$1.opened_projects,
          _record$1.organization,
          _record$1.permissions,
          projects,
          _record$1.proposal_builder,
          _record$1.proposals,
          _record$1.qualification_matrix,
          _record$1.route,
          _record$1.running_requests,
          _record$1.translations,
          _record$1.user,
          _record$1.sources_tooltip,
          _record$1.sources_tooltip_unsubscriber,
          _record$1.maintenance,
        );
      })(_pipe$1);
      return $pair.new$(_pipe$2, $effect.none());
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserAddedAttachments) {
    let id = msg.id;
    let attachments = msg.attachments;
    return [
      state,
      $effect.from(
        (dispatch) => {
          let _pipe = attachments;
          let _pipe$1 = $list.map(
            _pipe,
            (attachment) => {
              return $promise.map(
                $file.bytes(attachment),
                (body) => {
                  return $result.map(
                    $mime_types.from_string($file.mime(attachment)),
                    (mime) => {
                      return new $file_.File($file.name(attachment), body, mime);
                    },
                  );
                },
              );
            },
          );
          let _pipe$2 = $promise.await_list(_pipe$1);
          $promise.map(
            _pipe$2,
            (files) => {
              let _pipe$3 = files;
              let _pipe$4 = $result.all(_pipe$3);
              let _pipe$5 = $result.unwrap(_pipe$4, toList([]));
              let _pipe$6 = ((_capture) => {
                return new $msg.BrowserExtractedNewProjectAttachments(
                  id,
                  _capture,
                );
              })(_pipe$5);
              let _pipe$7 = new $msg.Project(_pipe$6);
              return dispatch(_pipe$7);
            },
          )
          return undefined;
        },
      ),
    ];
  } else if (msg instanceof $msg.UserExportedProject) {
    let project_id = msg.project_id;
    let $ = $assoc.get(state.projects, project_id);
    if ($ instanceof Ok) {
      let project = $[0];
      let name = ("\"" + project.name) + "\"";
      let msg$1 = ("Generating archive for project " + name) + ".";
      let msg$2 = $string.join(toList([msg$1, "Please, wait..."]), "\n");
      let _pipe = $toast.options();
      let _pipe$1 = $toast.sticky(_pipe);
      let _pipe$2 = $toast.notify(
        _pipe$1,
        (t) => { return new $msg.BrowserDisplayedToast(project_id, t); },
      );
      let _pipe$3 = $toast.custom(_pipe$2, msg$2);
      let _pipe$4 = $effect.map(
        _pipe$3,
        (var0) => { return new $msg.Project(var0); },
      );
      return ((_capture) => { return $pair.new$(state, _capture); })(_pipe$4);
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.BrowserDisplayedToast) {
    let project_id = msg.project_id;
    let toast_id = msg.toast_id;
    let $ = $assoc.get(state.projects, project_id);
    if ($ instanceof Ok) {
      let project = $[0];
      return [state, $project_effects.download(project, toast_id)];
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserWillDeleteProject) {
    let project_id = msg.project_id;
    let $ = $assoc.get(state.projects, project_id);
    if ($ instanceof Ok) {
      let project = $[0];
      echo("muf ?", "src/frontend/update/project.gleam", 174);
      let confirm_input = "";
      let modal = new $state.DeleteProject(project.id, confirm_input);
      return [
        (() => {
          let _record = state;
          return new State(
            _record.window_dimensions,
            _record.access_token,
            _record.analytics,
            _record.client,
            _record.collapsed_navbar,
            _record.comments,
            _record.comments_draft_mentions,
            _record.comments_in_edition,
            _record.connectors,
            _record.content_library,
            _record.copilot,
            _record.custom_rewording_input,
            _record.draft_comments,
            _record.dropdown_unsubscriber,
            _record.feed_opened,
            _record.language,
            _record.loading,
            modal,
            _record.modal_unsubscriber,
            _record.notifications,
            _record.notifications_unread,
            _record.opened_projects,
            _record.organization,
            _record.permissions,
            _record.projects,
            _record.proposal_builder,
            _record.proposals,
            _record.qualification_matrix,
            _record.route,
            _record.running_requests,
            _record.translations,
            _record.user,
            _record.sources_tooltip,
            _record.sources_tooltip_unsubscriber,
            _record.maintenance,
          );
        })(),
        $effect.none(),
      ];
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserDeletedProject) {
    let project_id = msg.project_id;
    return [
      (() => {
        let _record = state;
        return new State(
          _record.window_dimensions,
          _record.access_token,
          _record.analytics,
          _record.client,
          _record.collapsed_navbar,
          _record.comments,
          _record.comments_draft_mentions,
          _record.comments_in_edition,
          _record.connectors,
          _record.content_library,
          _record.copilot,
          _record.custom_rewording_input,
          _record.draft_comments,
          _record.dropdown_unsubscriber,
          _record.feed_opened,
          _record.language,
          _record.loading,
          new $state.NoModal(),
          _record.modal_unsubscriber,
          _record.notifications,
          _record.notifications_unread,
          _record.opened_projects,
          _record.organization,
          _record.permissions,
          _record.projects,
          _record.proposal_builder,
          _record.proposals,
          _record.qualification_matrix,
          _record.route,
          _record.running_requests,
          _record.translations,
          _record.user,
          _record.sources_tooltip,
          _record.sources_tooltip_unsubscriber,
          _record.maintenance,
        );
      })(),
      $project_effects.delete_project(project_id),
    ];
  } else if (msg instanceof $msg.UserEditedDeleteConfirmInput) {
    let confirm_input = msg.value;
    let _block;
    let _record = state;
    _block = new State(
      _record.window_dimensions,
      _record.access_token,
      _record.analytics,
      _record.client,
      _record.collapsed_navbar,
      _record.comments,
      _record.comments_draft_mentions,
      _record.comments_in_edition,
      _record.connectors,
      _record.content_library,
      _record.copilot,
      _record.custom_rewording_input,
      _record.draft_comments,
      _record.dropdown_unsubscriber,
      _record.feed_opened,
      _record.language,
      _record.loading,
      (() => {
        let $ = state.modal;
        if ($ instanceof $state.DeleteProject) {
          let id = $.id;
          return new $state.DeleteProject(id, confirm_input);
        } else {
          return state.modal;
        }
      })(),
      _record.modal_unsubscriber,
      _record.notifications,
      _record.notifications_unread,
      _record.opened_projects,
      _record.organization,
      _record.permissions,
      _record.projects,
      _record.proposal_builder,
      _record.proposals,
      _record.qualification_matrix,
      _record.route,
      _record.running_requests,
      _record.translations,
      _record.user,
      _record.sources_tooltip,
      _record.sources_tooltip_unsubscriber,
      _record.maintenance,
    );
    let _pipe = _block;
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.UserDisplayedModalChangeProjectStatus) {
    let project_id = msg.project_id;
    let status = msg.status;
    let modal = new $state.ChangeProjectStatus(project_id, status);
    let _block;
    let _record = state;
    _block = new State(
      _record.window_dimensions,
      _record.access_token,
      _record.analytics,
      _record.client,
      _record.collapsed_navbar,
      _record.comments,
      _record.comments_draft_mentions,
      _record.comments_in_edition,
      _record.connectors,
      _record.content_library,
      _record.copilot,
      _record.custom_rewording_input,
      _record.draft_comments,
      _record.dropdown_unsubscriber,
      _record.feed_opened,
      _record.language,
      _record.loading,
      modal,
      _record.modal_unsubscriber,
      _record.notifications,
      _record.notifications_unread,
      _record.opened_projects,
      _record.organization,
      _record.permissions,
      _record.projects,
      _record.proposal_builder,
      _record.proposals,
      _record.qualification_matrix,
      _record.route,
      _record.running_requests,
      _record.translations,
      _record.user,
      _record.sources_tooltip,
      _record.sources_tooltip_unsubscriber,
      _record.maintenance,
    );
    let state$1 = _block;
    return [state$1, $modal_effects.subscribe_close()];
  } else {
    let project_id = msg.id;
    let status = msg.status;
    let _pipe = $state.update_project_status(state, project_id, status);
    return ((state) => {
      return [
        state,
        $effect.batch(
          toList([
            $project_effects.update_project(state, project_id, true),
            $modal_effects.close(),
          ]),
        ),
      ];
    })(_pipe);
  }
}

function echo(value, file, line) {
  const grey = "\u001b[90m";
  const reset_color = "\u001b[39m";
  const file_line = `${file}:${line}`;
  const string_value = echo$inspect(value);

  if (globalThis.process?.stderr?.write) {
    // If we're in Node.js, use `stderr`
    const string = `${grey}${file_line}${reset_color}\n${string_value}\n`;
    process.stderr.write(string);
  } else if (globalThis.Deno) {
    // If we're in Deno, use `stderr`
    const string = `${grey}${file_line}${reset_color}\n${string_value}\n`;
    globalThis.Deno.stderr.writeSync(new TextEncoder().encode(string));
  } else {
    // Otherwise, use `console.log`
    // The browser's console.log doesn't support ansi escape codes
    const string = `${file_line}\n${string_value}`;
    globalThis.console.log(string);
  }

  return value;
}

function echo$inspectString(str) {
  let new_str = '"';
  for (let i = 0; i < str.length; i++) {
    let char = str[i];
    if (char == "\n") new_str += "\\n";
    else if (char == "\r") new_str += "\\r";
    else if (char == "\t") new_str += "\\t";
    else if (char == "\f") new_str += "\\f";
    else if (char == "\\") new_str += "\\\\";
    else if (char == '"') new_str += '\\"';
    else if (char < " " || (char > "~" && char < "\u{00A0}")) {
      new_str +=
        "\\u{" +
        char.charCodeAt(0).toString(16).toUpperCase().padStart(4, "0") +
        "}";
    } else {
      new_str += char;
    }
  }
  new_str += '"';
  return new_str;
}

function echo$inspectDict(map) {
  let body = "dict.from_list([";
  let first = true;

  let key_value_pairs = [];
  map.forEach((value, key) => {
    key_value_pairs.push([key, value]);
  });
  key_value_pairs.sort();
  key_value_pairs.forEach(([key, value]) => {
    if (!first) body = body + ", ";
    body = body + "#(" + echo$inspect(key) + ", " + echo$inspect(value) + ")";
    first = false;
  });
  return body + "])";
}

function echo$inspectCustomType(record) {
  const props = globalThis.Object.keys(record)
    .map((label) => {
      const value = echo$inspect(record[label]);
      return isNaN(parseInt(label)) ? `${label}: ${value}` : value;
    })
    .join(", ");
  return props
    ? `${record.constructor.name}(${props})`
    : record.constructor.name;
}

function echo$inspectObject(v) {
  const name = Object.getPrototypeOf(v)?.constructor?.name || "Object";
  const props = [];
  for (const k of Object.keys(v)) {
    props.push(`${echo$inspect(k)}: ${echo$inspect(v[k])}`);
  }
  const body = props.length ? " " + props.join(", ") + " " : "";
  const head = name === "Object" ? "" : name + " ";
  return `//js(${head}{${body}})`;
}

function echo$inspect(v) {
  const t = typeof v;
  if (v === true) return "True";
  if (v === false) return "False";
  if (v === null) return "//js(null)";
  if (v === undefined) return "Nil";
  if (t === "string") return echo$inspectString(v);
  if (t === "bigint" || t === "number") return v.toString();
  if (globalThis.Array.isArray(v))
    return `#(${v.map(echo$inspect).join(", ")})`;
  if (v instanceof $List)
    return `[${v.toArray().map(echo$inspect).join(", ")}]`;
  if (v instanceof $UtfCodepoint)
    return `//utfcodepoint(${String.fromCodePoint(v.value)})`;
  if (v instanceof $BitArray) return echo$inspectBitArray(v);
  if (v instanceof $CustomType) return echo$inspectCustomType(v);
  if (echo$isDict(v)) return echo$inspectDict(v);
  if (v instanceof Set)
    return `//js(Set(${[...v].map(echo$inspect).join(", ")}))`;
  if (v instanceof RegExp) return `//js(${v})`;
  if (v instanceof Date) return `//js(Date("${v.toISOString()}"))`;
  if (v instanceof Function) {
    const args = [];
    for (const i of Array(v.length).keys())
      args.push(String.fromCharCode(i + 97));
    return `//fn(${args.join(", ")}) { ... }`;
  }
  return echo$inspectObject(v);
}

function echo$inspectBitArray(bitArray) {
  // We take all the aligned bytes of the bit array starting from `bitOffset`
  // up to the end of the section containing all the aligned bytes.
  let endOfAlignedBytes =
    bitArray.bitOffset + 8 * Math.trunc(bitArray.bitSize / 8);
  let alignedBytes = bitArraySlice(
    bitArray,
    bitArray.bitOffset,
    endOfAlignedBytes,
  );

  // Now we need to get the remaining unaligned bits at the end of the bit array.
  // They will start after `endOfAlignedBytes` and end at `bitArray.bitSize`
  let remainingUnalignedBits = bitArray.bitSize % 8;
  if (remainingUnalignedBits > 0) {
    let remainingBits = bitArraySliceToInt(
      bitArray,
      endOfAlignedBytes,
      bitArray.bitSize,
      false,
      false,
    );
    let alignedBytesArray = Array.from(alignedBytes.rawBuffer);
    let suffix = `${remainingBits}:size(${remainingUnalignedBits})`;
    if (alignedBytesArray.length === 0) {
      return `<<${suffix}>>`;
    } else {
      return `<<${Array.from(alignedBytes.rawBuffer).join(", ")}, ${suffix}>>`;
    }
  } else {
    return `<<${Array.from(alignedBytes.rawBuffer).join(", ")}>>`;
  }
}

function echo$isDict(value) {
  try {
    // We can only check if an object is a stdlib Dict if it is one of the
    // project's dependencies.
    // The `Dict` class is the default export of `stdlib/dict.mjs`
    // that we import as `$stdlib$dict`.
    return value instanceof $stdlib$dict.default;
  } catch {
    // If stdlib is not one of the project's dependencies then `$stdlib$dict`
    // will not have been imported and the check will throw an exception meaning
    // we can't check if something is actually a `Dict`.
    return false;
  }
}

